import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AccountService, AlertDeliveryFailureRow } from '../services/account.service';

@Component({
  selector: 'app-account-settings-alert-delivery-failures',
  templateUrl: './alert-delivery-failures.component.html',
  styleUrls: ['./alert-delivery-failures.component.scss'],
})
export class AccountSettingsAlertDeliveryFailuresComponent implements OnInit {
  list: AlertDeliveryFailureRow[] = [];
  loading = false;
  error: string | null = null;
  searchSerial = '';

  constructor(
    private accountService: AccountService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    void this.loadFailures();
  }

  async loadFailures() {
    const accountId = this.accountService.getCurrentAccount();
    if (!accountId) {
      this.error = this.translate.instant('ADMIN.ALERT_DELIVERY_FAILURES_NO_ACCOUNT');
      return;
    }

    this.loading = true;
    this.error = null;

    try {
      this.list = await this.accountService.listAccountAlertDeliveryFailures(String(accountId), {
        serial: this.searchSerial.trim() || undefined,
      });
    } catch (e: any) {
      this.error = e?.error?.message || e?.message || this.translate.instant('ADMIN.ALERT_DELIVERY_FAILURES_LOAD_FAILURE');
      this.list = [];
    } finally {
      this.loading = false;
    }
  }

  formatDate(value: string | undefined): string {
    if (!value) {
      return '';
    }
    return new Date(value).toLocaleString();
  }

  formatFailureCategory(category: string | undefined): string {
    if (!category) {
      return '';
    }
    const key = `ADMIN.ALERT_DELIVERY_FAILURES_CATEGORY_${category.toUpperCase()}`;
    const translated = this.translate.instant(key);
    return translated === key ? category : translated;
  }

  formatChannel(channel: string | undefined): string {
    if (!channel) {
      return '';
    }
    const key = `ADMIN.ALERT_DELIVERY_FAILURES_CHANNEL_${channel.toUpperCase()}`;
    const translated = this.translate.instant(key);
    return translated === key ? channel : translated;
  }
}
